const root = document.documentElement;
const body = document.body;
const shopRoot = window.Shopify?.routes?.root || '/';
const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: body.dataset.currency || 'EUR' }).format(cents / 100);
const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
const cartDrawer = document.getElementById('CartDrawer');
const cartOverlay = document.getElementById('CartOverlay');
const cartItems = document.getElementById('CartItems');
const cartFoot = document.getElementById('CartFoot');
const cartCount = document.getElementById('CartCount');
const cartOpenButton = document.getElementById('CartOpen');
const menuButton = document.getElementById('MenuToggle');
const mainNavigation = document.getElementById('MainNav');
let lastFocusedElement = null;

const closeMenu = (restoreFocus = false) => {
  if (!menuButton || !mainNavigation) return;
  mainNavigation.classList.remove('open');
  menuButton.setAttribute('aria-expanded', 'false');
  if (restoreFocus) menuButton.focus();
};

const normalizeMediaUrl = (value) => {
  try {
    const url = new URL(value, window.location.href);
    return `${url.origin}${url.pathname}`;
  } catch {
    return value || '';
  }
};

const setActiveThumbnail = (scope, source) => {
  if (!scope || !source) return;
  const normalizedSource = normalizeMediaUrl(source);
  scope.querySelectorAll('[data-media-thumb]').forEach((thumbnail) => {
    const active = normalizeMediaUrl(thumbnail.dataset.mediaThumb) === normalizedSource;
    thumbnail.classList.toggle('is-active', active);
    thumbnail.setAttribute('aria-pressed', String(active));
  });
};

const openCart = async () => {
  lastFocusedElement = document.activeElement;
  await refreshCart();
  cartOverlay.hidden = false;
  cartDrawer.inert = false;
  cartDrawer.setAttribute('aria-hidden', 'false');
  cartDrawer.classList.add('open');
  cartOverlay.classList.add('open');
  cartOpenButton?.setAttribute('aria-expanded', 'true');
  body.classList.add('locked');
  document.getElementById('CartClose')?.focus();
};

const closeCart = () => {
  cartDrawer.classList.remove('open');
  cartOverlay.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartDrawer.inert = true;
  cartOverlay.hidden = true;
  cartOpenButton?.setAttribute('aria-expanded', 'false');
  body.classList.remove('locked');
  lastFocusedElement?.focus();
};

const renderCart = (cart) => {
  cartCount.textContent = cart.item_count;
  if (!cart.item_count) {
    cartItems.innerHTML = `<div class="empty"><strong>${escapeHtml(cartItems.dataset.emptyTitle)}</strong><p>${escapeHtml(cartItems.dataset.emptyCopy)}</p></div>`;
    cartFoot.classList.remove('active');
    return;
  }
  cartItems.innerHTML = cart.items.map((item, index) => `<article class="cart-item"><img src="${escapeHtml(item.image || '')}" alt=""><div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title || '')}</p><div class="mini-stepper"><button type="button" data-cart-line="${index + 1}" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Diminuer la quantité">−</button><span>${item.quantity}</span><button type="button" data-cart-line="${index + 1}" data-cart-quantity="${item.quantity + 1}" aria-label="Augmenter la quantité">+</button><button type="button" data-cart-line="${index + 1}" data-cart-quantity="0" data-remove>${escapeHtml(cartItems.dataset.remove)}</button></div></div><strong>${money(item.final_line_price)}</strong></article>`).join('');
  document.getElementById('CartSubtotal').textContent = money(cart.total_price);
  cartFoot.classList.add('active');
};

const refreshCart = async () => {
  const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart request failed');
  const cart = await response.json();
  renderCart(cart);
  return cart;
};

document.addEventListener('click', async (event) => {
  const clickedMenuButton = event.target.closest('#MenuToggle');
  if (clickedMenuButton) {
    const expanded = clickedMenuButton.getAttribute('aria-expanded') === 'true';
    clickedMenuButton.setAttribute('aria-expanded', String(!expanded));
    mainNavigation?.classList.toggle('open', !expanded);
  }
  if (event.target.closest('#MainNav a')) closeMenu();
  if (mainNavigation?.classList.contains('open') && !event.target.closest('.header')) closeMenu();
  if (event.target.closest('#CartOpen')) await openCart().catch(() => {});
  if (event.target.closest('#CartClose') || event.target === cartOverlay) closeCart();
  const priceChoice = event.target.closest('[data-price-choice]');
  if (priceChoice) {
    const dialog = document.getElementById(priceChoice.dataset.dialogId);
    if (dialog) {
      const quantity = dialog.querySelector('[data-choice-quantity]');
      const price = dialog.querySelector('[data-choice-price]');
      const syringes = dialog.querySelector('[data-choice-syringes]');
      const link10 = dialog.querySelector('[data-concentration-link="10"]');
      const link16 = dialog.querySelector('[data-concentration-link="16"]');
      if (quantity) quantity.textContent = priceChoice.dataset.quantity || '';
      if (price) price.textContent = priceChoice.dataset.price || '';
      // Slavic and Baltic languages need a different noun form per count, so the
      // label travels with the button rather than being a single fixed plural.
      if (syringes) syringes.textContent = priceChoice.dataset.syringes || '';
      if (link10 && priceChoice.dataset.urlTen) link10.href = priceChoice.dataset.urlTen;
      if (link16 && priceChoice.dataset.urlSixteen) link16.href = priceChoice.dataset.urlSixteen;
      dialog.showModal();
    }
  }
  const cartChange = event.target.closest('[data-cart-line]');
  if (cartChange) {
    cartChange.disabled = true;
    const response = await fetch(`${shopRoot}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(cartChange.dataset.cartLine), quantity: Number(cartChange.dataset.cartQuantity) }) });
    renderCart(await response.json());
  }
  const zoom = event.target.closest('[data-zoom-image]');
  if (zoom) {
    const dialog = document.getElementById(zoom.dataset.zoomDialog);
    dialog.querySelector('img').src = zoom.dataset.zoomImage;
    dialog.querySelector('img').alt = zoom.dataset.zoomAlt || '';
    dialog.showModal();
  }
  if (event.target.closest('[data-dialog-close]')) event.target.closest('dialog').close();
  if (event.target.matches('dialog.concentration-dialog')) event.target.close();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.ajax-cart-form');
  if (!form) return;
  event.preventDefault();
  const submit = form.querySelector('[type="submit"]');
  submit.disabled = true;
  try {
    const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Add to cart failed');
    await openCart();
    const toast = document.getElementById('CartToast');
    toast.textContent = form.closest('[data-product-scope]')?.dataset.successMessage || '';
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 2200);
  } finally {
    submit.disabled = false;
  }
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-selector]');
  if (!selector) return;
  const option = selector.selectedOptions[0];
  const scope = selector.closest('[data-product-scope]');
  const variantInput = scope.querySelector('[name="id"]');
  if (variantInput) variantInput.value = option.value;
  const price = scope.querySelector('[data-product-price]');
  if (price) price.textContent = option.dataset.price;
  const image = scope.querySelector('[data-product-image]');
  if (image && option.dataset.image) {
    image.src = option.dataset.image;
    image.srcset = '';
    if (option.dataset.imageAlt) image.alt = option.dataset.imageAlt;
    setActiveThumbnail(scope, option.dataset.image);
  }
  const content = scope.querySelector('[data-variant-content]');
  if (content) content.textContent = option.dataset.content || '';
});

document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-media-thumb]');
  if (!thumbnail) return;
  const scope = thumbnail.closest('[data-product-scope]');
  const image = scope?.querySelector('[data-product-image]');
  if (image) {
    image.src = thumbnail.dataset.mediaThumb;
    image.srcset = '';
    if (thumbnail.dataset.mediaAlt) image.alt = thumbnail.dataset.mediaAlt;
    setActiveThumbnail(scope, thumbnail.dataset.mediaThumb);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && cartDrawer?.classList.contains('open')) {
    closeCart();
    return;
  }
  if (event.key === 'Escape' && mainNavigation?.classList.contains('open')) {
    closeMenu(true);
    return;
  }
  if (event.key !== 'Tab' || !cartDrawer?.classList.contains('open')) return;
  const focusable = Array.from(cartDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => element.offsetParent !== null);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 900) closeMenu();
});

refreshCart().catch(() => {});
